import { apiWrapper } from '../helper/api-wrapper';

export const getOrders = async ({
  type = 'all',
  page = 0,
  limit = 2,
  search = '',
  date = '',
  dateEnd = '',
}) => {
  try {
    const response = await apiWrapper.get(
      `merchants/order/lists?type=${type}&offset=${page}&limit=${limit}&query=${search}&sdate=${date}&edate=${dateEnd}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrderDetail = async (id) => {
  try {
    const response = await apiWrapper.get(`merchants/order/detail/${id}`);

    return response;
  } catch (error) {
    throw error;
  }
};

export const rejectOrder = async (payload) => {
  try {
    const response = await apiWrapper.post(`merchants/order/reject`, payload);

    return response;
  } catch (error) {
    throw error;
  }
};

export const confirmOrder = async (payload) => {
  try {
    const response = await apiWrapper.post(`merchants/order/confirm`, payload);

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateStatusOrder = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/order/vendor_update`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const shippedStatusOrder = async (payload) => {
  try {
    const response = await apiWrapper.multipartPost(
      `merchants/order/shipped_V2`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const requestResolveOrder = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/order/request_resolve`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const packedStatusOrder = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/order/processing`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTrackingListOrder = async (shipperOrderId) => {
  try {
    const response = await apiWrapper.get(
      `shipper/order_status/${shipperOrderId}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};
